import { CSSProperties } from 'react';

import { AppColors } from '../../theme';

const styles: { [key: string]: CSSProperties } = {
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: AppColors.VA.PRIMARY._50_,
    color: AppColors.VA.NEUTRALS.WHITE,
    borderRadius: '8px',
    padding: '12px 24px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    minWidth: '85px',
    height: '40px',
    gap: '8px'
  },
  buttonHover: {
    backgroundColor: AppColors.VA.PRIMARY._50_,
    transform: 'translateY(-1px)',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
  },
  buttonDisabled: {
    border: `1px solid ${AppColors.VA.BACKGROUND._30_}`,
    backgroundColor: AppColors.VA.NEUTRALS._30_,
    color: AppColors.VA.NEUTRALS._50_,
    cursor: 'not-allowed',
    transform: 'none',
    boxShadow: 'none',
    fontWeight: 700
  }
};

export default styles;
